export const PUT_ACTIVITY_REPORT_COMMENT_REQUEST =
    'app/services/ActivityReportComment/PUT_ACTIVITY_REPORT_COMMENT_REQUEST';
export const PUT_ACTIVITY_REPORT_COMMENT_SUCCESS =
    'app/services/ActivityReportComment/PUT_ACTIVITY_REPORT_COMMENT_SUCCESS';
export const PUT_ACTIVITY_REPORT_COMMENT_FAILURE =
    'app/services/ActivityReportComment/PUT_ACTIVITY_REPORT_COMMENT_FAILURE';

export const actionPutActivityReportCommentRequest = () => ({
    type: PUT_ACTIVITY_REPORT_COMMENT_REQUEST,
});

export const actionPutActivityReportCommentSuccess = (data) => ({
    type: PUT_ACTIVITY_REPORT_COMMENT_SUCCESS,
    payload: data,
});

export const actionPutActivityReportCommentFailure = (error) => ({
    type: PUT_ACTIVITY_REPORT_COMMENT_FAILURE,
    error,
});
